<template>
	<div class="card" @mouseleave="mouseOver">
		<slot />
	</div>
</template>

<script>
export default {
	name: 'PCard',
	methods: {
		mouseOver() {
			this.$emit('mouseleave');
		},
	},
};
</script>

<style lang='scss' scoped>
.card {
	padding: 20px;
	border-radius: 9px;
	border: solid 1px #e9e9e9;
	background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/Card/p-card.vue